import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Swiper, Card, BlockHeader } from '@teko/ui';
import { ProductCombo } from './ProductCombo/ProductCombo.es.js';

const StyledSwiper = styled(Swiper)`
  .swiper-wrapper {
  }
`;
const ProductCombos = ({
  products,
  name,
  className
}) => {
  return /* @__PURE__ */ React.createElement(Card, {
    header: /* @__PURE__ */ React.createElement(BlockHeader, {
      title: t("Ti\u1EBFt ki\u1EC7m h\u01A1n khi mua c\xF9ng {{name}}", { name })
    }),
    className
  }, /* @__PURE__ */ React.createElement(StyledSwiper, {
    observer: true,
    observeParents: true,
    hasNavigation: true,
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 16
  }, products.map((product) => {
    return /* @__PURE__ */ React.createElement(ProductCombo, {
      productCombo: product,
      key: product.sku,
      linkDetail: product.linkDetail,
      linkBuy: product.linkBuy
    });
  })));
};

export { ProductCombos };
